import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react'
import './index.less'
import InfiniteScroll from 'react-infinite-scroll-component'
import Flex from '../Flex'
import { LoadingOutlined } from '@ant-design/icons'
import { Form, Tooltip } from 'antd'
import defaultlogo from '../../assets/images/template-default.png'
import Loading from '../Loading'

type ItemProps = {
    type: string
    fetchTemplateEnv: () => Promise<any>

    ref?: any
}

// 空白模板
export const defaultTemplate = {
    id: 'default-template-id',
    name: '空白模板',
    logo: defaultlogo,
    description: '这是一个空白模板',
    location: 'default-template-location',
}

let Item: React.FC<ItemProps> = (props, ref) => {

    const { fetchTemplateEnv, type } = props

    const form = Form.useFormInstance()
    const [data, setData] = useState<any>([])
    const [hasMore, sethasMore] = useState(false)
    const [empty, setEmpty] = useState(false)
    const [loading, setLoading] = useState(false)
    const template = Form.useWatch('template', form)
    const [pageEnd, setPageEnd] = useState(40)  // 因为接口没有分页，为了防止过多的渲染问题，做一个假分页

    const fetchData = async () => {
        setLoading(true)
        setPageEnd(40)
        const res = await fetchTemplateEnv().catch(() => { })
        if (type === 'ALL' && res) {
            res.unshift({ ...defaultTemplate })
        }
        setData(res ?? [])
        setEmpty(!res?.length)
        setLoading(false)
    }

    useEffect(() => {
        fetchData()
    }, [])

    useImperativeHandle(ref, () => ({
        reFresh: async () => {
            await fetchData()
        }
    }))


    return (
        <div className='ExperEnvCenter-list' id={`ExperEnvCenter-list-id-${type}`}>
            {
                loading ? <Loading /> :
                    empty ? <Flex gap={20} vertical align='center' justify='center'>
                        <img style={{ width: '140px' }} src={require('../../assets/images/nodata.png')} alt="" />
                        <span style={{ color: '#999999' }}>这里还没有任何内容哦~</span>
                    </Flex> : <InfiniteScroll
                        dataLength={data.slice(0, pageEnd).length}
                        next={() => { setPageEnd(pageEnd + 40) }}
                        hasMore={data.length > pageEnd}
                        height='100%'
                        loader={<Flex align='center' justify='center' style={{ color: '#999999', width: '100%' }}><LoadingOutlined />加载中…</Flex>}
                        scrollableTarget={`ExperEnvCenter-list-id-${type}`}
                    // endMessage={<Flex align='center' justify='center' style={{ color: '#999999', width: '100%' }}>没有更多了</Flex>}
                    >
                        {
                            data.slice(0, pageEnd).map((item: any) => {
                                return <div key={item?.location} data-select={template?.location === item?.location} className='ExperEnvCenter-list-item' onClick={() => {
                                    form.setFieldValue('template', template?.location === item?.location ? undefined : item)
                                }}>
                                    <img src={item?.logo} alt="" />
                                    <Flex vertical justify='space-between' gap={0} style={{ flex: '1', width: '10px' }} >
                                        <Tooltip
                                            placement="bottomLeft"
                                            title={item?.name}
                                            arrow={false}
                                            color='white'
                                            overlayClassName='custom-tooltip'
                                        >
                                            <div style={{ color: '#333333', fontWeight: '500' }} className='os-ellipsis'>{item?.name}</div>
                                        </Tooltip>
                                        <div className='os-ellipsis-two'>{item?.description}</div>
                                        {
                                            item?.labInfo ? <Flex align='center' gap={4}>
                                                <img style={{ width: '16px', height: '16px', borderRadius: '50%' }} src={item?.labInfo?.logo} alt="" />
                                                <Tooltip
                                                    placement="bottomLeft"
                                                    title={item?.labInfo?.name}
                                                    arrow={false}
                                                    color='white'
                                                    overlayClassName='custom-tooltip'
                                                >
                                                    <div style={{ flex: '1 0 0' }} className='os-ellipsis'>{item?.labInfo?.name}</div>
                                                </Tooltip>
                                            </Flex> : <div></div>
                                        }
                                    </Flex>
                                </div>
                            })
                        }
                    </InfiniteScroll>
            }
        </div>
    )
}

Item = forwardRef(Item as any)

export default Item